 
import Button from "@material-ui/core/Button";
 
const index = ({additionClass,loading=false,text,handleClick,Icon}) => {
    return (
      
        <Button
            className={"image-btn "+additionClass}
            onClick={handleClick}
            type="submit"
            variant="contained"
            disabled={loading}
            startIcon={Icon}           
            >
           
           { text }
        </Button>
       
    );
  }
  
  export default index;
  